import mixpanel from "mixpanel-browser";
import * as amplitude from "@amplitude/analytics-browser";

type Object = "Signup" | "Tour" | "Subscription" | "Tab" | "Page";
type Action =
  | "Started"
  | "Completed"
  | "Viewed"
  | "Upgraded"
  | "Downgraded"
  | "Cancelled"
  | "Created"
  | "Changed"
  | "Deleted";

const isProd = import.meta.env.VITE_ENV === "production";
const enableAnalytics = isProd;

if (enableAnalytics) {
  mixpanel.init("35d95208da6ab88475f29199f2ce05ed", {
    track_pageview: true,
    persistence: "localStorage",
  });

  amplitude.init("9c3e149304729c6f22a8614d688e744");
}

export const analytics = {
  /**
   * Assigns the current session to a particular user
   * @param id Unique id of the user we want to assign the current session to — currently the user's email
   * @example analytics.identify("user@example.com")
   */
  identify: (id: string) => {
    if (!enableAnalytics) return;
    mixpanel.identify(id);
    amplitude.setUserId(id);
  },
  /**
   * Resets the current session and removes any assigned user
   * @example analytics.reset()
   */
  reset: () => {
    if (!enableAnalytics) return;
    mixpanel.reset();
    amplitude.reset();
  },
  /**
   * Tracks an event in the current session
   * @param event Id of the event we want to track — `Proper Casing` with Object followed by an Action in past tense
   * @param data Any additional data we want to track
   * @example analytics.track("Signup Completed", { plan: 'basic' })
   */
  track: (event: `${Object} ${Action}`, data?: any) => {
    if (!enableAnalytics) return;
    mixpanel.track(event, data);
    amplitude.track(event, data);
  },

  /**
   * The amount of viewing time a tab is counted as a new event
   */
  tabTimeout: 5000, // 5s
};
